var React = require('react');
var ReactDOM = require('react-dom');
var $ = require('jquery');
var SelectDropdown = require('patternity/lib/select_dropdown');
const { getAllLanguages } = require('../corporate/components/preview_email/api');

function languageSwitcher() {
  function build() {
    ReactDOM.render(<LanguageSwitcher />, document.getElementById('language-switcher'));
    document.getElementById('language-switcher').style.display = "block";
  }
  return {
    build: build
  }
}

var LanguageSwitcher = React.createClass({
  displayName: "LanguageSwitcher",

  getInitialState : function () {
    return {
      challengeId: null,
      languages : [],
      currentLanguage: window._infl.hub.lang,
      missingTranslations: false
    };
  },

  componentDidMount : function () {
    this._fetchLanguages();
  },

  render : function(){
    return (
        <SelectDropdown
            key='language-selector'
            id='language-selector'
            value={this.state.currentLanguage}
            onChange={this._onLanguageChange}>
            { this._buildLanguageOptions() }
        </SelectDropdown>
    );
  },

  _fetchLanguages: function() {
    getAllLanguages()
      .then(function(response) {
        this.setState({ languages: response.data.languages });
      }.bind(this));
  },

  _onLanguageChange: function(e) {
    const lang = e.target.value;
    this.setState({ currentLanguage: lang });
    this._handlePreview(e);
  },

  _handlePreview: function(e) {
    var $iframe = $("iframe#challenge-preview");
    var challengeId = $iframe.attr('src').includes('http')
      ? $iframe.attr('src').split('/')[5] : $iframe.attr('src').split('/')[3];
    $iframe.attr('src', '/corporate/challenges/' + challengeId + '/preview?lang=' + e.target.value);
  },

  _buildLanguageOptions: function() {
    return this.state.languages.map(function(language) {
      return (<option key={language.value} value={language.value}>{language.label}</option>)
    });
  }

});

export default languageSwitcher;



// WEBPACK FOOTER //
// ./src/shared/language-switcher.js